import { Button, styled } from '@mui/material';

const TransparentButton = styled(Button)(({ theme }) => ({
    backgroundColor: theme.palette.background.default,
    color: theme.palette.text.primary,
    border: '1px solid var(--lm-border)',
    boxShadow: 'none',
}));

export default TransparentButton;
